import React, {useState} from "react";

import {useTranslation} from "react-i18next";
import {queries} from "shared/api/queries";
import client from "api/client";
import {DraggableModal} from "shared/ui/modal/draggableModal";
import {useToast} from "shared/ui";
import {getApiErrorMsg} from "shared/lib/fns";
import {IPlanShortItem, TUpdatePlanAPIData} from "features/plan/types";
import {LoadingSpinner} from "shared/assets/svgs/LoadingSpinner";
import {PlanList} from "features/plan/components/modal/PlanList";

interface Props {
  trackingNumbers: string[];
  onShifted: () => void;
  onHide: () => void;
}

export const ShiftPlanPopup = ({
                                 onShifted, onHide, trackingNumbers
                               }: Props) => {
  const toast = useToast();
  const {t} = useTranslation("shipping");
  const [selectedPlan, setSelectedPlan] = useState<IPlanShortItem>();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleShift = () => {
    if (!!selectedPlan) {
      setIsLoading(true);
      const data: TUpdatePlanAPIData = {
        plan_date: selectedPlan.plan_date,
        plan_no: selectedPlan.plan_no,
        dest_plan_id: selectedPlan.id,
        tracking_number_list: trackingNumbers,
      };
      client
      .post<TUpdatePlanAPIData>(queries.plan.shift, data)
      .then(onShifted)
      .catch((e) => {
        toast.error(getApiErrorMsg(e));
      })
      .finally(() => {
        setIsLoading(false);
      });
    }
    else {
      toast.error(t("Please, select plan to be shifted"));
    }
  };
  
  return (<DraggableModal
    width={335}
    title={t("shift plan")}
    cancelText={t("popup.btn.back")}
    showCancel
    confirmText={t("shift plan")}
    onConfirm={handleShift}
    onClose={onHide}
  >
    <PlanList selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} />
    {isLoading && (<div className={"spinner"}>
      <LoadingSpinner />
    </div>)}
  </DraggableModal>);
};
